export default __webpack_public_path__ + "static/media/overviewBannerDesktop.4164fb9d.png";